import React from 'react';
import Classes from './Classes';
import Goals from './Goals';
import './Main.css';

function Main() {
    return (
        <div className="main">
            <div className="main__container">
                <Classes />
                <Goals />
            </div>
        </div>
    )
}

export default Main
